import { Component, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { AccessibilityFontSizeSetterService } from './accessibility-font-size-setter.service';

@Component({
  selector: 'app-accessibility-font-size-setter',
  templateUrl: './accessibility-font-size-setter.component.html',
  styleUrls: ['./accessibility-font-size-setter.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AccessibilityFontSizeSetterComponent implements OnInit {
  @Output() fontSizePercentageChanged = new EventEmitter();
  @Output() setDefaultFontSizePercentage = new EventEmitter();

  public fontSizePercentage: number;

  constructor(private _accessibilityFontSizeSetterService: AccessibilityFontSizeSetterService) {
  }

  ngOnInit() {
    this._accessibilityFontSizeSetterService.setFontSize();
    this.fontSizePercentage = this._accessibilityFontSizeSetterService.fontSizePercentage;
    this.setDefaultFontSizePercentage.emit(this.fontSizePercentage);
  }

  public onValueChanged(event): void {
    this.fontSizePercentage = event;
    this.fontSizePercentageChanged.emit(this.fontSizePercentage);
  }

  public saveFontSizePercentageToStorage(): void {
    this._accessibilityFontSizeSetterService.saveFontSizeToStorage(this.fontSizePercentage);
  }
}
